import handleGetOrSearchFileProviderItemsResponse from './handleGetOrSearchFileProviderItemsResponse';
import { getFileProviderItems as getFileProviderItemsServiceCall } from 'owa-fileprovider-items-service';
import GetFileProviderItemsResponse from '../../types/GetFileProviderItemsResponse';
import AttachmentDataProviderScope from 'owa-service/lib/contract/AttachmentDataProviderScope';
import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import AttachmentItemsFilterBy from 'owa-service/lib/contract/AttachmentItemsFilterBy';
import AttachmentItemsPagingMetadata from 'owa-service/lib/contract/AttachmentItemsPagingMetadata';
import AttachmentItemsSort from 'owa-service/lib/contract/AttachmentItemsSort';

// If an error is encountered and the promise is broken we throw an AttachmentResultCode that is handled by the caller.
export default async function getFileProviderItems(
    fileProviderType: AttachmentDataProviderType,
    fileProviderId: string,
    offset: number,
    filterBy: AttachmentItemsFilterBy,
    scope: AttachmentDataProviderScope = null,
    endpointUrl: string = null,
    folderId?: string,
    location?: string,
    pagingMetadata: AttachmentItemsPagingMetadata = null,
    sort?: AttachmentItemsSort
): Promise<GetFileProviderItemsResponse> {
    const response = await getFileProviderItemsServiceCall(
        fileProviderType,
        fileProviderId,
        offset,
        filterBy,
        scope,
        endpointUrl,
        folderId,
        location,
        pagingMetadata,
        sort
    );

    const items = handleGetOrSearchFileProviderItemsResponse(response, fileProviderId);
    return {
        items: items,
        totalItemsCount: response.TotalItemCount,
        pagingMetadata: response.PagingMetadata,
    };
}
